import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import * as React from "react";
import { isTabKey, isHideMenuKey } from "../../utils/keyboardUtils.es.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.es.js";
import { GridMenu } from "../menu/GridMenu.es.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { gridClasses } from "../../constants/gridClasses.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import useId from "../../../utils/useId/useId.es.js";
import useForkRef from "../../../utils/useForkRef/useForkRef.es.js";
import MenuList from "../../../material/MenuList/MenuList.es.js";
const _excluded = ["children", "onClick"];
const GridToolbarExportContainer = /* @__PURE__ */ React.forwardRef(function GridToolbarExportContainer2(props, ref) {
  var _rootProps$slotProps;
  const {
    children,
    onClick
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const exportButtonId = useId();
  const exportMenuId = useId();
  const [open, setOpen] = React.useState(false);
  const buttonRef = React.useRef(null);
  const handleRef = useForkRef(ref, buttonRef);
  const handleMenuOpen = (event) => {
    setOpen((prevOpen) => !prevOpen);
    onClick == null || onClick(event);
  };
  const handleMenuClose = () => setOpen(false);
  const handleListKeyDown = (event) => {
    if (isTabKey(event.key)) {
      event.preventDefault();
    }
    if (isHideMenuKey(event.key)) {
      handleMenuClose();
    }
  };
  if (children == null) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.baseButton, _extends({
      ref: handleRef,
      size: "small",
      startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.exportIcon, {}),
      "aria-expanded": open,
      "aria-label": apiRef.current.getLocaleText("toolbarExportLabel"),
      "aria-haspopup": "menu",
      "aria-controls": open ? exportMenuId : void 0,
      id: exportButtonId
    }, other, {
      onClick: handleMenuOpen
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseButton, {
      children: apiRef.current.getLocaleText("toolbarExport")
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(GridMenu, {
      open,
      target: buttonRef.current,
      onClose: handleMenuClose,
      position: "bottom-start",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList, {
        id: exportMenuId,
        className: gridClasses.menuList,
        "aria-labelledby": exportButtonId,
        onKeyDown: handleListKeyDown,
        autoFocusItem: open,
        children: React.Children.map(children, (child) => {
          if (!/* @__PURE__ */ React.isValidElement(child)) {
            return child;
          }
          return /* @__PURE__ */ React.cloneElement(child, {
            hideMenu: handleMenuClose
          });
        })
      })
    })]
  });
});
export {
  GridToolbarExportContainer
};
//# sourceMappingURL=GridToolbarExportContainer.es.js.map
